import { render, staticRenderFns } from "./QuotesTableActions.vue?vue&type=template&id=0c021042&"
import script from "./QuotesTableActions.vue?vue&type=script&lang=js&"
export * from "./QuotesTableActions.vue?vue&type=script&lang=js&"
import style0 from "./QuotesTableActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports